
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 17 17","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M13.166 15.167H3.833A1.333 1.333 0 012.5 13.834V4.5a1.333 1.333 0 011.333-1.333h1.333V1.834H6.5v1.333h4V1.834h1.333v1.333h1.333A1.333 1.333 0 0114.5 4.5v9.334a1.333 1.333 0 01-1.333 1.333zm-9.333-8v6.667h9.333V7.167H3.833zm0-2.667v1.333h9.333V4.5H3.833z"}})])
          )
        }
      }
    